class Map {
    constructor() {
        this.map = document.querySelector('.js-map');
        this.mapMockup = document.querySelector('.js-map-mockup');
        this.trigger = document.querySelector('.js-map-trigger');

        if (this.map && this.trigger) {
            this.iframeSrc = this.map.dataset.iframeSrc;

            this.initEvent(this.trigger);
        }
    }

    initEvent(element) {
        element.addEventListener('click', () => { this.switchContent(); });
    }

    switchContent() {
        if (this.map.style.display !== 'block') {
            this.mapMockup.style.display = 'none';
            this.map.style.display = 'block';

            this.map.src = this.iframeSrc;
        } else {
            this.mapMockup.style.display = 'block';
            this.map.style.display = 'none';
        }
    }
}

const map = {
    init() {
        return new Map();
    },
};

export default map;
